// extracted by mini-css-extract-plugin
export default {"main_wrapper":"MainWrapper_main_wrapper__Tuw2x"};